module.exports = __webpack_public_path__ + "img/iconmenu.52ed594d.png";